import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { RegionPage } from "@/components/calv/RegionPage";

export const Route = createFileRoute("/regionen/wuerzburg")({
  head: () => {
    const h = pageHead("region:wuerzburg", "de");
    return { meta: h.meta, links: h.links };
  },
  component: () => <RegionPage slug="wuerzburg" locale="de" />,
});
